module.exports = __webpack_public_path__ + "img/field-level-endzone-gal-5.f43f5ed4.jpg";